'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';

const FlagCocAsset = ({ width, height, ...props }, ref) => /* @__PURE__ */ jsxs(
  "svg",
  {
    viewBox: "0 0 28 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width,
    height,
    ref,
    "aria-hidden": true,
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M-1.14441e-05 -1.52588e-05C9.33333 -1.52588e-05 18.6667 -0.000184041 28 2.65241e-06V20C18.6667 20 9.33333 20 -1.04308e-06 20C-1.04308e-06 13.3333 6.59936e-05 6.66665 -1.14441e-05 -1.52588e-05Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M-1.14441e-05 -1.52588e-05L28 2.65241e-06V20H-1.04308e-06L-1.14441e-05 -1.52588e-05Z",
          fill: "#19BFBF"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M13.4442 3.33334C13.3721 3.33334 13.3019 3.35673 13.2442 3.40001L10.7203 5.29295C10.6848 5.31961 10.6443 5.33889 10.6012 5.34966L8.0353 5.99113C8.0117 5.99703 7.98882 6.00549 7.96707 6.01637L5.43251 7.28365C5.368 7.3159 5.31569 7.36821 5.28344 7.43272L4.08631 9.82699C4.03281 9.93398 4.04074 10.0614 4.1071 10.161L5.27715 11.916C5.31365 11.9708 5.33313 12.0351 5.33313 12.1009V13.8619C5.33313 13.9503 5.36825 14.0351 5.43076 14.0976L6.49658 15.1635C6.59803 15.2649 6.75302 15.2901 6.88135 15.2259L10.5961 13.3685C10.6424 13.3454 10.6934 13.3333 10.7452 13.3333H13.2124C13.2904 13.3333 13.3659 13.3607 13.4258 13.4106L17.2404 16.5894C17.3003 16.6393 17.3758 16.6667 17.4538 16.6667H19.8214C19.9328 16.6667 20.0369 16.611 20.0988 16.5182L22.6105 12.7506C22.647 12.6959 22.6665 12.6316 22.6665 12.5657V10.1009C22.6665 10.0351 22.647 9.97079 22.6105 9.91603L19.9998 6L18.0969 2.82851C18.0367 2.7281 17.9282 2.66667 17.8111 2.66667H17.3925C17.1246 2.66667 16.9904 2.99061 17.1799 3.18007C17.2714 3.2716 17.2941 3.41143 17.2362 3.52722L16.7586 4.48241C16.7021 4.59534 16.5867 4.66667 16.4604 4.66667H14.8725C14.7462 4.66667 14.6308 4.59534 14.5743 4.48241L14.0919 3.5176C14.0355 3.40467 13.92 3.33334 13.7938 3.33334H13.4442Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M19.3332 17.3333H17.9998L18.4308 17.7643C18.561 17.8945 18.772 17.8945 18.9022 17.7643L19.3332 17.3333Z",
          fill: "white"
        }
      )
    ]
  }
);
const VpFlagCocAsset = forwardRef(FlagCocAsset);

export { VpFlagCocAsset as default };
